import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider } from "@/context/LanguageContext";
import { AuthProvider } from "@/context/AuthContext";
import { Layout } from "@/components/Layout";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { AuthCallback } from "@/components/AuthCallback";

import Home from "@/pages/Home";
import About from "@/pages/About";
import Markets from "@/pages/Markets";
import MarketDetail from "@/pages/MarketDetail";
import Workshops from "@/pages/Workshops";
import Vendors from "@/pages/Vendors";
import VendorDetail from "@/pages/VendorDetail";
import Artisans from "@/pages/Artisans";
import ArtisanDetail from "@/pages/ArtisanDetail";
import MarketApply from "@/pages/MarketApply";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import VendorRegister from "@/pages/VendorRegister";
import Member from "@/pages/Member";
import VendorDashboard from "@/pages/VendorDashboard";
import AdminDashboard from "@/pages/AdminDashboard";

function AppRoutes() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/markets" element={<Markets />} />
        <Route path="/markets/:id" element={<MarketDetail />} />
        <Route path="/workshops" element={<Workshops />} />
        <Route path="/vendors" element={<Vendors />} />
        <Route path="/vendors/:slug" element={<VendorDetail />} />
        <Route path="/artisans" element={<Artisans />} />
        <Route path="/artisans/:slug" element={<ArtisanDetail />} />
        <Route path="/apply" element={<MarketApply />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/vendor-register" element={<VendorRegister />} />
        <Route path="/member" element={<ProtectedRoute><Member /></ProtectedRoute>} />
        <Route path="/vendor" element={<ProtectedRoute roles={["vendor"]}><VendorDashboard /></ProtectedRoute>} />
        <Route path="/admin" element={<ProtectedRoute roles={["admin"]}><AdminDashboard /></ProtectedRoute>} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <AuthProvider>
          <BrowserRouter>
            <AppRoutes />
            <Toaster position="bottom-center" richColors />
          </BrowserRouter>
        </AuthProvider>
      </LanguageProvider>
    </div>
  );
}

export default App;
